/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  numberLabel: {
    id: 'ari.type.number.label',
    defaultMessage: 'Number',
  },
  textLabel: {
    id: 'ari.type.text.label',
    defaultMessage: 'Text',
  },
  dropdownLabel: {
    id: 'ari.type.dropdown.label',
    defaultMessage: 'Dropdown',
  },
  createGlobalButtonLabel: {
    id: 'ari.create.global.btn.label',
    defaultMessage: 'Create global ARI fields',
  },
  manageGlobalButtonLabel: {
    id: 'ari.manage.global.btn.label',
    defaultMessage: 'Manage global ARI fields',
  },
  createLocalButtonLabel: {
    id: 'ari.create.local.btn.label',
    defaultMessage: 'Create local ARI fields',
  },
  manageLocalButtonLabel: {
    id: 'ari.manage.local.btn.label',
    defaultMessage: 'Manage local ARI fields',
  },
  subaccountCreateButtonLabel: {
    id: 'ari.sub.create.btn.label',
    defaultMessage: 'Create ARI fields',
  },
  subaccountManageButtonLabel: {
    id: 'ari.sub.manage.btn.label',
    defaultMessage: 'Manage ARI fields',
  },
  ariFieldsNotEnabledMessage: {
    id: 'ari.local.fields.not.enabled.message',
    defaultMessage: 'Local ARI fields are not enabled for this account.',
  },
  gdprAgreementTitle: {
    id: 'ari.gdpr.agreement.title',
    defaultMessage: 'I hereby declare that:',
  },
  gdprAgreementPartOne: {
    id: 'ari.gdpr.agreement.part.one',
    defaultMessage: 'Any Additional Respondent Information we collect or enter and any information entered in a respondent\'s Notes field is relevant and vital to our internal processes;',
  },
  gdprAgreementPartTwo: {
    id: 'ari.gdpr.agreement.part.two',
    defaultMessage: 'Any Additional Respondent Information we collect or enter and any information entered in a respondent\'s Notes field does not contain any kind of sensitive data such as, for example but not limited to, political or sexual orientation, race, religion, or any other information considered sensitive according to GDPR and/or other applicable data privacy laws and regulations;',
  },
  gdprAgreementPartThree: {
    id: 'ari.gdpr.agreement.part.three',
    defaultMessage: 'We accept sole and full responsibility for the usage and processing of collected or entered Additional Respondent Information and respondent Notes.',
  },
  gdprSubmitButtonLabel: {
    id: 'ari.gdpr.submit.label',
    defaultMessage: 'Submit Declaration',
  },
  allowLocalFieldUseYesLabel: {
    id: 'ari.allow.local.field.use.yes',
    defaultMessage: 'YES',
  },
  allowLocalFieldUseNoLabel: {
    id: 'ari.allow.local.field.use.no',
    defaultMessage: 'NO',
  },
  allowSubaccountsLocalFieldUseQuestion: {
    id: 'ari.allow.local.field.use.question',
    defaultMessage: 'Can sub-accounts use local ARI fields?',
  },
  allowFieldUseForSuperLinks: {
    id: 'ari.allow.field.use.for.superlinks.question',
    defaultMessage: 'Will fields be visible in SuperLink Self Registration?',
  },
  allowFieldUseForQuestionnaires: {
    id: 'ari.allow.field.use.for.questionnaires.question',
    defaultMessage: 'Will fields be visible in GDPR questionnaires?',
  },
  questionLabel: {
    id: 'ari.table.header.question',
    defaultMessage: 'Question',
  },
  typeLabel: {
    id: 'ari.table.header.type',
    defaultMessage: 'Type',
  },
  fieldListCurrentFields: {
    id: 'ari.field.list.current.fields',
    defaultMessage: 'Current fields:',
  },
  noGlobalAriCreated: {
    id: 'ari.no.global.created.message',
    defaultMessage: 'No global ARI fields created yet.',
  },
  noLocalAriCreated: {
    id: 'ari.no.local.created.message',
    defaultMessage: 'No local ARI fields created yet.',
  },
  ariPanelHeader: {
    id: 'ari.panel.header',
    defaultMessage: 'Additional Respondent Information',
  },
  globalCreatePanelHeader: {
    id: 'ari.global.create.panel.header',
    defaultMessage: 'Create GLOBAL ARI fields',
  },
  localCreatePanelHeader: {
    id: 'ari.local.create.panel.header',
    defaultMessage: 'Create LOCAL ARI fields',
  },
  globalManagePanelHeader: {
    id: 'ari.global.manage.panel.header',
    defaultMessage: 'Manage GLOBAL ARI fields',
  },
  globalManageEnforcedDialogHeader: {
    id: 'ari.global.manage.enforced.dialog.header',
    defaultMessage: 'Choose the accounts this global ARI is enforced upon.',
  },
  localManagePanelHeader: {
    id: 'ari.local.manage.panel.header',
    defaultMessage: 'Manage LOCAL ARI fields',
  },
  globalManageNoFields: {
    id: 'ari.global.manage.noFields.message',
    defaultMessage: 'No global fields to manage.',
  },
  localManageNoFields: {
    id: 'ari.local.manage.noFields.message',
    defaultMessage: 'No local fields to manage.',
  },
  newQuestionType: {
    id: 'ari.dropdown.type.label',
    defaultMessage: 'New question type:',
  },
  dropdownPlaceholder: {
    id: 'ari.dropdown.type.placeholder',
    defaultMessage: 'choose ...',
  },
  questionValidationMaxLength: {
    id: 'ari.validation.questio.max.length',
    defaultMessage: 'No more than 250 characters allowed.',
  },
  questionValidationRequired: {
    id: 'ari.validation.question.required',
    defaultMessage: 'Question field is required.',
  },
  questionValidationMandatory: {
    id: 'ari.validation.mandatory.required',
    defaultMessage: 'Mandatory field is required.',
  },
  answerValidationMaxLength: {
    id: 'ari.validation.answer.max.length',
    defaultMessage: 'No more than 50 characters allowed.',
  },
  answerValidationRequired: {
    id: 'ari.validation.answer.required',
    defaultMessage: 'Answer is required.',
  },
  answerListEmptyMessage: {
    id: 'ari.answer.list.empty',
    defaultMessage: 'No answers added yet.',
  },
  answerListLabelMessage: {
    id: 'ari.answer.list.label.message',
    defaultMessage: 'Answers for this question (click to remove):',
  },
  answersLabel: {
    id: 'ari.answer.label',
    defaultMessage: 'answers',
  },
  answerFieldPlaceholder: {
    id: 'ari.answer.field.placeholder',
    defaultMessage: 'enter answer option ...',
  },
  addAnswerBtnLabel: {
    id: 'ari.answer.add.btn.label',
    defaultMessage: 'Add answer',
  },
  submitLabel: {
    id: 'ari.btn.submit.label',
    defaultMessage: 'Submit',
  },
  enterQuestionPlaceholder: {
    id: 'ari.question.text.area.placeholder',
    defaultMessage: 'enter question ...',
  },
  editQuestionDialogHeader: {
    id: 'ari.edit.question.dialog.header',
    defaultMessage: 'Update question',
  },
  editDropdownAnswersDialogHeader: {
    id: 'ari.edit.answers.dialog.header',
    defaultMessage: 'Update answers for question',
  },
  updateLabel: {
    id: 'ari.btn.update.label',
    defaultMessage: 'Update',
  },
  cancelLabel: {
    id: 'ari.btn.cancel.label',
    defaultMessage: 'Cancel',
  },
  manageDeleteLabel: {
    id: 'ari.manage.delete.label',
    defaultMessage: 'Remove',
  },
  manageEnforceLabel: {
    id: 'ari.manage.enforce.label',
    defaultMessage: 'Enforce on',
  },
  enforceAllLabel: {
    id: 'ari.manage.enforce.all.label',
    defaultMessage: 'All',
  },
  enforceNoneLabel: {
    id: 'ari.manage.enforce.none.label',
    defaultMessage: 'None',
  },
  enforceResetLabel: {
    id: 'ari.manage.enforce.reset.label',
    defaultMessage: 'Reset',
  },
  manageMandatoryLabel: {
    id: 'ari.manage.mandatory.label',
    defaultMessage: 'Answer mandatory',
  },
  // growl messages
  growlToggleAllowSubaccountsFieldUseSummary: {
    id: 'ari.growl.toggle.local.field.use.summary',
    defaultMessage: 'Update local ARI fields use',
  },
  growlToggleAllowSubaccountsFieldUseSuccess: {
    id: 'ari.growl.toggle.local.field.use.success',
    defaultMessage: 'Updated.',
  },
  growlToggleUseInSuperLinkSuccessSummary: {
    id: 'ari.growl.toggle.superlink.use.success.summary',
    defaultMessage: 'ARI field use',
  },
  growlToggleUseInSuperLinkSuccessDetail: {
    id: 'ari.growl.toggle.superlink.use.success.detail',
    defaultMessage: 'ARI field use for SuperLinks updated.',
  },
  growlToggleUseInQuestionnairesSuccessSummary: {
    id: 'ari.growl.toggle.questionnaires.use.success.summary',
    defaultMessage: 'ARI field use',
  },
  growlToggleUseInQuestionnairesSuccessDetail: {
    id: 'ari.growl.toggle.questionnaires.use.success.detail',
    defaultMessage: 'ARI field use for questionnaires updated.',
  },
  growlToggleAllowSubaccountsFieldUseFail: {
    id: 'ari.growl.toggle.local.field.use.fail',
    defaultMessage: 'Operation failed.',
  },
  growlGdprAgreementSummary: {
    id: 'ari.grow.gdpr.summary',
    defaultMessage: 'GDPR Acceptance',
  },
  growlGdprAgreementFail: {
    id: 'ari.growl.gdrp.agreement.fail',
    defaultMessage: 'An error occurred.',
  },
  growlGdprAgreementSuccess: {
    id: 'ari.growl.gdpr.agreement.success',
    defaultMessage: 'Success. Declaration submitted.',
  },
  growlAddFieldSuccessSummary: {
    id: 'ari.growl.add.field.success.summary.msg',
    defaultMessage: 'Success.',
  },
  growlAddFieldFailSummary: {
    id: 'ari.growl.add.field.fail.summary.msg',
    defaultMessage: 'Error.',
  },
  growlAddDropdownFieldSuccessDetail: {
    id: 'ari.growl.add.dropdown.field.success.detail.msg',
    defaultMessage: 'Dropdown ARI field added.',
  },
  growlAddDropdownFieldFailDetail: {
    id: 'ari.growl.add.dropdown.field.fail.detail.msg',
    defaultMessage: 'There was a problem adding a new dropdown ARI field.',
  },
  growlAddNumberFieldSuccessDetail: {
    id: 'ari.growl.add.number.field.success.detail.msg',
    defaultMessage: 'Number ARI field added.',
  },
  growlAddNumberFieldFailDetail: {
    id: 'ari.growl.add.number.field.fail.detail.msg',
    defaultMessage: 'There was a problem adding a new number ARI field.',
  },
  growlAddTextFieldSuccessDetail: {
    id: 'ari.growl.add.text.field.success.detail.msg',
    defaultMessage: 'Text ARI field added.',
  },
  growlAddTextFieldFailDetail: {
    id: 'ari.growl.add.Text.field.fail.detail.msg',
    defaultMessage: 'There was a problem adding a new text ARI field.',
  },
  growlEditQuestionSuccessDetail: {
    id: 'ari.growl.edit.question.success.detail',
    defaultMessage: 'Question updated.',
  },
  growlEditQuestionFailDetail: {
    id: 'ari.growl.edit.question.fail.detail',
    defaultMessage: 'There was a problem updating the ARI question.',
  },
  growlEditAnswersSuccessDetail: {
    id: 'ari.growl.edit.answers.success.detail',
    defaultMessage: 'Answers updated.',
  },
  growlEditAnswersFailDetail: {
    id: 'ari.growl.answers.fail.detail',
    defaultMessage: 'There was a problem updating answers for this ARI field.',
  },
  growlDeleteAriSuccessDetail: {
    id: 'ari.growl.delete.field.success.detail',
    defaultMessage: 'ARI field deleted.',
  },
  growlDeleteAriFailDetail: {
    id: 'ari.growl.delete.field.fail.detail',
    defaultMessage: 'There was an error deleting this ARI field.',
  },
  growlAccountEnforceSuccessDetail: {
    id: 'ari.growl.account.enforce.success.detail',
    defaultMessage: 'Sub-accounts on which global fields are enforced have been updated.',
  },
  growlAccountEnforceFailDetail: {
    id: 'ari.growl.account.enforce.fail.detail',
    defaultMessage: 'There was an error when enforcing global ARI fields on sub-accounts.',
  },
  growlToggleMandatorySuccessDetail: {
    id: 'ari.growl.toggle.mandatory.success.detail',
    defaultMessage: 'Mandatory option for field changed.',
  },
  growlToggleMandatoryFailDetail: {
    id: 'ari.grow.toggle.mandatory.fail.detail',
    defaultMessage: 'There was an error changing the mandatory option for this field.',
  },
  growlRankChangedSuccessDetail: {
    id: 'ari.growl.rank.changed.success.detail',
    defaultMessage: 'ARI field rank updated.',
  },
  growlRankChangedFailDetail: {
    id: 'ari.growl.rank.changed.fail.detail',
    defaultMessage: 'There was an error changing the rank for this ARI field.',
  },
});

export default messages;
